// extracted by mini-css-extract-plugin
module.exports = {"container":"e7","image":"e8","title":"e9","desc":"e-"};